import { Navigate, Route, Routes } from 'react-router-dom'

import { Layout } from '../shared/components/Layout'
import { ProtectedRoute } from '../shared/components/ProtectedRoute'
import { AuthCallbackPage } from '../modules/auth/pages/AuthCallbackPage'
import { LoginPage } from '../modules/auth/pages/LoginPage'
import { AdminPage } from '../modules/admin/pages/AdminPage'
import { ArticleDetailPage } from '../modules/article/pages/ArticleDetailPage'
import { ArticleFormPage } from '../modules/article/pages/ArticleFormPage'
import { DashboardPage } from '../modules/dashboard/pages/DashboardPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <DashboardPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/articles/new"
        element={
          <ProtectedRoute>
            <Layout>
              <ArticleFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/articles/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <ArticleDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/articles/:id/edit"
        element={
          <ProtectedRoute>
            <Layout>
              <ArticleFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute role={['admin', 'publisher']}>
            <Layout>
              <AdminPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
